import { Component,
         EventEmitter,
         Input,
         Output,
         OnInit,
         ViewChild, 
         ChangeDetectorRef} from '@angular/core'

import { RecaptchaComponent } from 'ng-recaptcha'

import { AppConstants } from 'src/app/_core/index'

@Component({
  moduleId: module.id,
  selector: 'ss-recaptcha-input',
  templateUrl: 'recaptcha-input.component.html',
  styleUrls: ['recaptcha-input.component.scss']
})

export class RecaptchaInputComponent implements OnInit {

  @Input() disabled: boolean
  @Input() error: boolean

  @Output() onCorrectCaptcha = new EventEmitter<string>()
  @Output() onExpiredCaptcha = new EventEmitter<string>()

  @ViewChild('recaptchaComponent') recaptcha: RecaptchaComponent

  googleRecaptchaKey: string = AppConstants.RECAPTCHA_SITE_KEY

  response: any

  constructor(
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // this.googleRecaptchaKey = AppConstants.RECAPTCHA_SITE_KEY
    this.detectChanges()
  }

  reset() {
    // note: beware of infinite loop: https://github.com/DethAriel/ng-recaptcha/issues/139
    if (this.response) { this.recaptcha.reset() }
  }

  handleCorrectCaptcha(response: any) {
    this.onCorrectCaptcha.emit(response)
  }

  handleExpiredCaptcha(response?: any) {
    this.onExpiredCaptcha.emit(response)
    // this.recaptcha.reset()
  }

  handleCaptchaResolved(response: any) {
    this.response = response
    if (!response) return this.handleExpiredCaptcha()
    this.handleCorrectCaptcha(response)
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}
